import { getClientId } from "@smartsheet/lodestar-utils";
import React, { useState, useEffect } from "react";

interface HiddenInputProps<SelectionType, ValueGetter extends (value: SelectionType) => string> {
    clientId: string | undefined;
    selectionType: SelectionType;
    getHiddenInputValue?: ValueGetter;
    hiddenInputName?: string;
}

export const HiddenInput = <SelectionType, ValueGetter extends (selectionType: SelectionType) => string>({
    clientId,
    hiddenInputName,
    getHiddenInputValue,
    selectionType,
}: HiddenInputProps<SelectionType, ValueGetter>) => {
    const [hiddenInputValue, setHiddenInputValue] = useState<string | undefined>(undefined);

    useEffect(() => {
        if (getHiddenInputValue && selectionType) {
            setHiddenInputValue(getHiddenInputValue(selectionType));
        }
    }, [selectionType, getHiddenInputValue]);

    const shouldRender = hiddenInputName && hiddenInputValue !== undefined;

    return shouldRender
        ? (
              <input
                  name={hiddenInputName}
                  value={hiddenInputValue}
                  hidden
                  readOnly
                  data-client-id={getClientId(clientId, "-hidden-input")}
              />
          ) || null
        : null;
};
